<template>
    <div class="code-wrap" :class="refer" v-if="code">
        <div class="code-title">服务券码: {{ code }}</div>
        <div id="qr-img" ></div>
    </div>
  </template>
  <script>
import create from '../create'
import QRCode from 'qrcode2';
export default create({
    name: 'service-qr-code',
    components: {
    },
    props: {
        code: String || Number || Boolean,
        refer: {
            type: String,
            default: "code-success"
        },
    },
    data() {
        return {

        }
    },
    mounted() {
        this.$nextTick(() => {
            if(!this.code)return 
            const widthPX = document.documentElement.clientWidth * (470/1080)
            new QRCode(document.getElementById('qr-img'), {
                width: widthPX,
                height: widthPX,
                text:String(this.code)
            });
        })
    },
    computed: {
    },
    methods: {
    }
})
  </script>
  <style lang="scss" scoped>
  .code-wrap{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
    .code-title{
        flex-basis: 100%;
        color: #333;
        font-size: 42px;
        @include os-font-weight(42, 50);
        line-height: 48px;
    }
    #qr-img{
        max-width: 470px;
        max-height: 470px;
        display: inline-block;
        overflow: hidden;
    }
    &.code-success{
        #qr-img{
            margin-top: 32px;
        }
    }
    &.order-detail{
        #qr-img{
            margin-top: 56px;
        }
    }

}
  </style>